import { ActionIcon, Box, Center, Group, Text, Tooltip } from '@mantine/core';
import { IconMicrophone, IconMicrophoneOff, IconVideo, IconVideoOff } from '@tabler/icons-react';

/** Before joining: the camera preview, with mic and camera toggles that carry into the call. */
export function ChimeJoinPreview({
  preview,
}: {
  preview: {
    videoRef: (el: HTMLVideoElement | null) => void;
    micOn: boolean;
    cameraOn: boolean;
    setMicOn: (on: boolean) => void;
    setCameraOn: (on: boolean) => void;
  };
}): JSX.Element {
  return (
    <Box
      style={{
        position: 'relative',
        width: 560,
        maxWidth: '100%',
        aspectRatio: '16 / 9',
        background: 'black',
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      {preview.cameraOn ? (
        <video
          ref={preview.videoRef}
          autoPlay
          playsInline
          muted
          style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)' }}
        />
      ) : (
        <Center h="100%">
          <Text c="dimmed">Camera is off</Text>
        </Center>
      )}
      <Group gap="sm" style={{ position: 'absolute', bottom: 12, left: '50%', transform: 'translateX(-50%)' }}>
        <Tooltip label={preview.micOn ? 'Mute' : 'Unmute'}>
          <ActionIcon
            size="xl"
            radius="xl"
            variant="filled"
            color={preview.micOn ? 'gray' : 'red'}
            aria-label="Mute microphone"
            aria-pressed={!preview.micOn}
            onClick={() => preview.setMicOn(!preview.micOn)}
          >
            {preview.micOn ? <IconMicrophone size={22} /> : <IconMicrophoneOff size={22} />}
          </ActionIcon>
        </Tooltip>
        <Tooltip label={preview.cameraOn ? 'Turn camera off' : 'Turn camera on'}>
          <ActionIcon
            size="xl"
            radius="xl"
            variant="filled"
            color={preview.cameraOn ? 'gray' : 'red'}
            aria-label="Turn camera off"
            aria-pressed={!preview.cameraOn}
            onClick={() => preview.setCameraOn(!preview.cameraOn)}
          >
            {preview.cameraOn ? <IconVideo size={22} /> : <IconVideoOff size={22} />}
          </ActionIcon>
        </Tooltip>
      </Group>
    </Box>
  );
}
